import _ from 'lodash';
import { createSelector } from 'reselect';

const selectAppStore = (store) => store.app;

export const selectIsOfflineStatusBarHidden = createSelector(
  [selectAppStore],
  (appStore) => _.getNonEmpty(appStore, 'hideOfflineStatusBar', false)
);
